import { render, staticRenderFns } from "./Sanitaire.vue?vue&type=template&id=d2cd5f42&"
import script from "./Sanitaire.vue?vue&type=script&lang=js&"
export * from "./Sanitaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports